<template>
  <div class="empower">
    <Navbar :default-bg="false"/>
    <div class="apply">
      <span>申请授权</span>
      <span>APPLY FOR AUTHORIZATION /</span>
    </div>
    <div class="apply-msg">
      <div class="msg-item">
        <div class="dot" @click="isAgree(0)">
          <span v-if="agree[0].status"></span>
        </div>
        <p>获取你的账号信息（Openid、地区）</p>
      </div>
      <div class="msg-item">
        <div class="dot" @click="isAgree(1)">
          <span v-if="agree[1].status"></span>
        </div>
        <p>
          <span>阅读并同意:</span>《<span @click="toPages('/userAgreeOn')">用户注册协议</span>》、《<span
            @click="toPages('/serviceTerms')">用户服务条款</span>》、
          《<span @click="toPages('/userConceal')">隐私协议</span>》
        </p>
      </div>
    </div>
    <div class="agreement">
      <button @click="getEmpower">已阅读并同意授权</button>
      <button @click="$router.go(-1)">取消</button>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import {Toast} from "vant";

export default {
  name: "Empower",
  components: {Navbar},
  data() {
    return {
      agree: [{status: true}, {status: true}],
    };
  },


  methods: {
    toPages(url) {
      this.$router.push(url);
    },
    getEmpower() {
      if (!this.agree[0].status || !this.agree[1].status) {
        return Toast("请同意并勾选用户协议");
      }
      // const local = decodeURIComponent(window.sessionStorage.getItem("skipAddress")) || this.BASE.BASE_URL;
      const local = this.BASE.BASE_URL + "/loading";

      window.location.replace(`${this.BASE.WECHAT_AUTHORIZE_URL}?returnUrl=${local}`);
    },
    isAgree(index) {
      this.agree[index].status = !this.agree[index].status;
    },
  },
};
</script>

<style scoped lang="less">
.empower {
  height: 100vh;
  background: #ffffff;
  font-size: 12px;

  .apply {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 38px;
    padding: 0 24px;
    box-sizing: border-box;

    span:nth-child(1) {
      font-size: 24px;
      font-weight: bold;
      padding-left: 3px;
    }

    span:nth-child(2) {
      color: #cccccc;
      margin-top: 11px;
    }
  }

  .apply-msg {
    margin-top: 52px;
    padding: 0 50px 0 25px;
    box-sizing: border-box;

    .msg-item:first-child {
      margin-top: 0;
    }

    .msg-item:nth-child(2) {
      color: #999999;

      span {
        color: #000000;
      }
    }

    .msg-item {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 22px;

      p {
        margin: 0;
        padding: 0;
      }

      .dot {
        width: 15px;
        height: 15px;
        background: #e5ffea;
        border: 1px solid #57bf6a;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #57bf6a;
        }
      }

      p {
        flex: 1;
        margin-left: 11px;
        line-height: 1.3;
      }
    }
  }

  .agreement {
    margin-top: 166px;
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
      width: 166px;
      height: 37px;
      background: transparent;
      border: none;
      font-size: 15px;
      font-weight: bold;
      border-radius: 5px;
    }

    button:first-child {
      background: #57bf6a;
      color: #ffffff;
    }

    button:nth-child(2) {
      background: #f2f2f2;
      color: #57bf6a;
      margin-top: 20px;
    }
  }
}
</style>